var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteSvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 26,
    height: 26,
    rx: 4,
    fill: "#FF7000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M18.9135 8.52955C18.8235 8.20151 18.7635 8.01927 18.7635 8.01927C18.666 7.68029 18.4185 7.68029 18.0509 7.62197L16.0595 7.37777C15.812 7.33767 15.812 7.33767 15.7145 7.12991C15.3882 6.41552 15.2869 6 14.9306 6H11.0677C10.7115 6 10.614 6.41552 10.2877 7.13356C10.1902 7.33767 10.1902 7.33767 9.94263 7.38141L7.94744 7.62562C7.58365 7.68394 7.32112 7.71674 7.22361 8.05571C7.22361 8.05571 7.17861 8.20515 7.08485 8.52955C6.96484 8.96329 6.91608 8.91591 7.32862 8.91591H18.6698C19.0823 8.91955 19.0373 8.96329 18.9135 8.52955ZM17.6272 10.0823H8.37123C7.74867 10.0823 7.71866 10.1625 7.75617 10.6181L8.45749 19.4606C8.51749 19.9089 8.5625 20 9.1138 20H16.8846C17.4359 20 17.4809 19.9089 17.5409 19.4606L18.2422 10.6181C18.2797 10.1588 18.2497 10.0823 17.6272 10.0823Z",
    fill: "#FF7000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSvgIcon);
export default __webpack_public_path__ + "static/media/deleteSVGIcon.f2d0b55005f6c1397f2be5f9406535be.svg";
export { ForwardRef as ReactComponent };